export default __webpack_public_path__ + "static/media/AvatarDino.5bfee7e6.svg";